<template>
  <button type="submit" class="btn-plyo-default" :class="{ 'processing-click': processingClick }" @click.prevent="onButtonClicked">
    <div class="button-text">{{ buttonText }}</div>
    <circular-loader />
  </button>
</template>

<script>
  import CircularLoader from './CircularLoader.vue'

  export default {
    components: {
      CircularLoader,
    },
    props: {
      buttonText: String,
      processingClick: Boolean,
    },
    methods: {
      onButtonClicked() {
        this.$emit('onButtonClicked');
      }
    }
  }
</script>

